module.exports = __webpack_public_path__ + "img/7_no.bcf08786.svg";